require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-workshops-stronger-after-the-baby.json") })
        }
      }, "path---courses-workshops-stronger-after-the-baby");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-workshops-stronger-after-the-baby!./.cache/json/courses-workshops-stronger-after-the-baby.json
// module id = 316
// module chunks = 231608221292675